<template>
  <section>
    <!--工具条-->
    <toolbar :buttonList="buttonList" @callFunction="callFunction">
      <template v-slot:before>
        <el-form-item>
          <el-select
            v-model="selStatus"
            placeholder="请选择状态"
            clearable
            collapse-tags
            style="width: 150px !important"
          >
            <el-option
              v-for="(item, key) in $t('TourDiy.ShopStatusList')"
              :key="key"
              :label="item"
              :value="parseInt(key)"
            ></el-option>
          </el-select>
        </el-form-item>
      </template>
    </toolbar>

    <!--列表-->
    <el-table
      ref="listTable"
      :data="list"
      highlight-current-row
      v-loading="listLoading"
      @current-change="selectCurrentRow"
      style="width: 100%"
      :height="getTableHeight(165)"
      size="small"
      fit
      row-key="Id"
    >
      <el-table-column :label="$t('Cover')" width="100">
        <template slot-scope="scope">
          <div
            v-if="
              scope.row.ShopInfo.Cover != null && scope.row.ShopInfo.Cover != ''
            "
            class="coverimg"
            :style="{
              backgroundImage:
                'url(' + baseCoverUrl + scope.row.ShopInfo.Cover + ')',
            }"
          ></div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('Name')" width="150">
        <template slot-scope="scope">{{
          field(scope.row.ShopInfo.Name)
        }}</template>
      </el-table-column>
      <el-table-column label="派送时间" width="220">
        <template slot-scope="scope">{{ scope.row.ShippingDateTime }}</template>
      </el-table-column>
      <el-table-column label="拼单进度" width="300">
        <template slot-scope="scope">
          <TourDiyProgress
            :progressData="scope.row.AwardList"
            :ItemCount="scope.row.ItemCount"
          ></TourDiyProgress>
        </template>
      </el-table-column>
      <el-table-column :label="$t('Status')" width="80">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.Status == 1 ? 'success' : 'warning'"
            disable-transitions
            >{{ $t("TourDiy.StatusList")[scope.row.Status] }}</el-tag
          ></template
        >
      </el-table-column>
      <el-table-column :label="'提醒' + $t('Status')" width="110">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.IsSend ? 'success' : 'danger'"
            disable-transitions
            >{{ scope.row.IsSend ? "已提醒" : "未提醒" }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column label="配送" width="100">
        <template slot-scope="scope">{{
          scope.row.ShopInfo.DeliveryModel == 1 ? "商家自送" : "车队配送"
        }}</template>
      </el-table-column>
      <el-table-column label="假人/总人数" width="100" prop="ItemCount">
        <template slot-scope="scope"
          >{{ scope.row.DummyCount }}/{{ scope.row.ItemCount }}</template
        ></el-table-column
      >
      <el-table-column :label="$t('operation')" width="200">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="small"
            @click="openDummy(scope.row.Id)"
            >机器人</el-button
          >
          <el-button
            type="success"
            size="small"
            @click="openOrder(scope.row.Id)"
            >查看订单</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="total,prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="50"
        :total="total"
        style="float: right"
      ></el-pagination>
    </el-col>

    <!--新增界面-->
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
      size="small"
    >
      <el-form :model="addForm" label-width="80px" ref="addForm">
        <el-form-item
          label="商家"
          prop="Shop_Id"
          :rules="{ required: true, message: $t('pleaseEnter') + '商家' }"
        >
          <el-select
            v-model="addForm.Shop_Id"
            filterable
            remote
            clearable
            placeholder="请输入关键词"
            :remote-method="shopRemoteMethod"
            @change="addShopChange"
            :loading="selectShoploading"
          >
            <el-option
              v-for="item in shopList"
              :key="item.Id"
              :label="field(item.Name)"
              :value="item.Id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="时段"
          prop="ShippingTime_Id"
          :rules="{ required: true, message: $t('pleaseEnter') + '时段' }"
        >
          <el-cascader
            clearable
            style="width: 300px"
            :options="shippingList"
            @change="addShippinghandleChange"
          ></el-cascader>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
    <TourDiyDummy ref="tourDiyDummyDialog"></TourDiyDummy>
    <TourDiyOrderList ref="tourDiyOrderListDialog"></TourDiyOrderList>
  </section>
</template>

<script>
import util from "util/date";
import TourDiyProgress from "@/components/TourDiyProgress";
import TourDiyDummy from "./TourDiyDummy";
import TourDiyOrderList from "./TourDiyOrderList";
import {
  base,
  getTourDiyList,
  addTourDiy,
  editTourDiy,
  getShopList,
  getShippingList,
} from "@/api/api";
import { getButtonList } from "@/promissionRouter";
export default {
  components: {
    TourDiyProgress,
    TourDiyDummy,
    TourDiyOrderList,
  },
  data() {
    return {
      filters: {
        Name: "",
      },
      buttonList: [],
      list: [],
      total: 0,
      page: 1,
      listLoading: false,
      currentRow: null,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      //编辑界面数据
      editForm: {},

      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      //新增界面数据
      addForm: {},
      baseCoverUrl: base + "/FileUpload/ShopCover/b0/",
      selectShoploading: false,
      selectShippingloading: false,
      shopList: [],
      shippingList: [],
      selStatus: null,
    };
  },
  provide() {
    return {
      getTourDiyList: this.getList,
    };
  },
  methods: {
    openDummy(id) {
      this.$refs.tourDiyDummyDialog.loadData(id);
    },
    openOrder(id) {
      this.$refs.tourDiyOrderListDialog.loadData(id);
    },
    shopRemoteMethod(query) {
      if (query !== "") {
        let para = {
          key: query,
        };
        this.selectShoploading = true;
        getShopList(para).then((res) => {
          this.shopList = res.data.response.data;
          this.selectShoploading = false;
        });
      } else {
        this.shopList = [];
      }
    },
    addShopChange(val) {
      let para = {
        shopId: val,
      };
      this.selectShippingloading = true;
      getShippingList(para).then((res) => {
        this.shippingList = res.data.response;
        this.selectShippingloading = false;
      });
    },
    addShippinghandleChange(value) {
      this.addForm.ShippingDate = value[0];
      this.addForm.ShippingTime_Id = value[1];
    },
    getShopStatusType(Status) {
      switch (Status) {
        case 1:
          return "danger";
        case 2:
          return "warning";
        case 3:
          return "success";
      }
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters = {
        Name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    formatDate: function (val) {
      return util.formatDate.format(new Date(val), "yyyy-MM-dd");
    },
    searchList() {
      this.page = 1;
      this.getList();
    },
    //获取列表
    getList() {
      let _this = this;
      let para = {
        page: this.page,
        status: this.selStatus == "" ? 0 : this.selStatus,
        key: this.filters.Name,
      };
      this.listLoading = true;
      getTourDiyList(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.list = res.data.response.data;
        this.listLoading = false;
      });
    }, //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {};
    }, //新增
    addSubmit: function () {
      let _this = this;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            let para = Object.assign({}, this.addForm);

            addTourDiy(para).then((res) => {
              this.addLoading = false;
              if (util.isEmt.format(res)) {
                return;
              }
              if (res.data.success) {
                this.addLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.getList();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
  },
  mounted() {
    this.getList();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>
<style>
.imgdiv {
  display: flex;
  align-content: center;
  text-align: center;
  justify-content: center;
}
</style>
